import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IVendorData } from "../../model/IVendorData";
import { InfoResponse } from "../FTypes";

export default class InfoDataParser implements IBaseDataParser<IVendorData> {
    check(data: InfoResponse<unknown>): boolean {
        return !!data?.settings;
    }

    parse(data: InfoResponse<unknown>): IVendorData {
        return {
            settings: data.settings
        };
    }
}
